import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const rscuTool: Tool = {
  id: "rscu",
  name: () => m.rscu_tool_name(),
  description: () => m.rscu_tool_description(),
  icon: "🧬",
  basePath: "/rscu",
  status: "stable",
  tags: ["bioinformatics", "dna", "rna", "codon", "science", "rscu"],
};
